package com.eladfinish.bible.contest.ui.utils

import androidx.compose.runtime.Composable

// A browser has no Back event a page can take over wholesale: its Back button moves through the
// tab's history. That history is bound to the app's navigation in RootContentJs.kt, which is also
// where a screen's back interceptor (InterceptBackWhen) gets its say on the browser's Back —
// see WebBackInterception there. So there is nothing left for this handler to do on web.
@Composable
actual fun MyBackHandler(enabled: Boolean, onBack: () -> Unit): Unit = Unit
